// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-c298af02]{display:none}.home[data-v-c298af02]{margin:0 auto;max-width:1200px;padding:0 16px;width:calc(100% - 32px)}@media(min-width:1024px){.home[data-v-c298af02]{padding:0}}.home[data-v-c298af02] .container__title{padding:1rem;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
